export const API_BASE_URL =
  process.env.GATSBY_API_BASE_URL || 'https://api.garaaz.com/api';
